module.exports = __webpack_public_path__ + "static/media/NAUT.ffe95b5a.png";